import axios from "axios";
import { N1CO_BASE_URL, N1CO_CLIENT_ID, N1CO_CLIENT_SECRET } from "../config";
import type { N1coTokenResponse } from "../types/n1co.types";

let cachedToken: string | null = null;
let cachedExpiry = 0;

export async function getToken(): Promise<string> {
  if (cachedToken && Date.now() < cachedExpiry) {
    return cachedToken;
  }

  const payload = {
    clientId: N1CO_CLIENT_ID,
    clientSecret: N1CO_CLIENT_SECRET,
  };

  const resp = await axios.post<N1coTokenResponse>(
    `${N1CO_BASE_URL}/token`,
    payload,
    { headers: { "Content-Type": "application/json" } }
  );

  const token = resp.data.accessToken;
  if (!token) {
    throw new Error("No se recibió token de acceso");
  }

  cachedToken = token;
  // margen de 60s antes de expirar:
  cachedExpiry = Date.now() + (resp.data.expiresIn - 60) * 1000;
  return cachedToken;
}
